"use client";

import { type ReactNode, useState } from "react";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
// import { ReactQueryStreamedHydration } from "@tanstack/react-query-next-experimental";
// Snackbar
import { SnackbarProvider } from "notistack";

export default function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 1000,
          },
        },
      }),
  )

  return (
    // <SnackbarProvider
    //   maxSnack={3}
    //   anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
    // >
      <QueryClientProvider client={queryClient}>
        {/*<ReactQueryStreamedHydration>*/}
          {children}
        {/*</ReactQueryStreamedHydration>*/}
        {<ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    // </SnackbarProvider>
  );
}
